import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../../../public/logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Sinter Batterires",
  class: "brand-image elevation-3",
  src: _imports_0,
  style: {"opacity":"0.8"}
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "brand-text font-weight-light" }, "Admin", -1)
const _hoisted_3 = { class: "sidebar" }
const _hoisted_4 = { class: "user-panel mt-3 pb-3 mb-3 d-flex" }
const _hoisted_5 = { class: "image" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "mt-2" }
const _hoisted_9 = {
  class: "nav nav-pills nav-sidebar flex-column",
  "data-accordion": "false",
  "data-widget": "treeview",
  role: "menu"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_menu_item = _resolveComponent("app-menu-item")!

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass([_ctx.sidebarSkin, "main-sidebar elevation-4"])
  }, [
    _createVNode(_component_router_link, {
      class: "brand-link",
      to: "/"
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: 
              // user && user.picture
              //     ? user.picture
              //     :
              require('@/assets/img/default-profile.png')
            ,
            alt: "User Image",
            class: "img-circle elevation-2"
          }, null, 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, {
            class: "d-block",
            to: "/profile"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.user && _ctx.user.email), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("nav", _hoisted_8, [
        _createElementVNode("ul", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item) => {
            return (_openBlock(), _createBlock(_component_app_menu_item, {
              key: item.name,
              menuItem: item
            }, null, 8, ["menuItem"]))
          }), 128))
        ])
      ])
    ])
  ], 2))
}